import { Component } from 'preact';
import PageTitle from '../../components/page-title';

class NotFoundPage extends Component {

	componentDidMount() {
		this.context.titleService.update('Not Found');
		this.context.tracking.recordPageView();
	}

	render() {
		return (
			<div>
				<PageTitle>Page Not Found</PageTitle>

				<p>
					Hmmmm, the page you were looking for doesn't appear to exist.
					If you believe this is in error, feel free to email me:
				</p>
				<p>
					<a href="mailto:feedback@howickweather.co.nz">feedback@howickweather.co.nz</a>
				</p>
			</div>
		);
	}
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./routes/not-found/index.js